module.exports = __webpack_public_path__ + "static/media/municipality.1190cee2.csv";